var exports = {
  "wj": "CardFrame__1Wp4YM",
  "fG": "DraggedCard__OxZ-2v",
  "ol": "CardMenu__23RGhi",
  "jn": "CardMenuInline__ibr793",
  "uJ": "CardMenuRevealOnHover__azFU5J",
  "se": "CardMenuDecoration__N240tm",
};

module.exports = exports;
